import type { ReactNode } from "react";

/** A pill you pick (design: 8x14 padding, gold when chosen). */
export function Choice({
  label,
  selected,
  onClick,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={`rounded-pill border-[1.5px] px-3.5 py-2 text-[13px] ${selected ? "border-gold bg-gold font-extrabold text-gold-ink" : "border-ink/40 bg-ink/6 font-bold text-ink"}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

/**
 * One setting inside the table settings panel (owner's design, 17 Sept 2026): small caps label on
 * the left, its choices on the right, a hairline above. On a narrow screen the choices wrap under
 * the label. A fieldset, so the label names the group.
 */
export function Panel({ label, children }: { label: string; children: ReactNode }) {
  return (
    <fieldset className="m-0 min-w-0 border-0 border-t border-ink/10 px-5 py-3.5">
      <legend className="sr-only">{label}</legend>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2.5">
        <span
          aria-hidden="true"
          className="w-[150px] flex-none text-[11px] font-bold uppercase tracking-[0.1em] text-ink/60"
        >
          {label}
        </span>
        <div className="flex min-w-0 flex-1 basis-[220px] flex-wrap gap-2">{children}</div>
      </div>
    </fieldset>
  );
}
